import { createAction } from '@reduxjs/toolkit';

export const setProfilePictureId = createAction<string | null>('SET_PROFILE_PICTURE_ID');
